module.exports = __webpack_public_path__ + "assets/xmcyber_com_no_text.9fffdbfe.svg";